<template>
  <div id="name-search">
    <b-row>
      <b-col>
        <b-form @submit.prevent="searchName">
          <b-form-group>
            <b-input-group>
              <b-form-input
                name="name"
                type="text"
                :id="parent + '-search'"
                v-model="name"
                placeholder="Search by name"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  :disabled="name.length < 3"
                  type="submit"
                  variant="primary"
                  >Search</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-form>
        <p class="error" v-if="name.length < 3">
          Please enter at least three characters to search
        </p>
        <div v-if="loading">
          <p>Loading...</p>
          <b-spinner></b-spinner>
        </div>
        <p v-if="error">
          No matching {{ table }} were found. Please search again
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "NameSearch",
  props: {
    table: String,
    parent: String,
  },
  methods: {
    ...mapActions({
      SEARCH_STUDENTS: "searches/GET_STUDENTS_BY_NAME",
      SEARCH_TEACHERS: "searches/GET_TEACHERS_BY_NAME",
      SEARCH_SCHOOLS: "searches/GET_SCHOOLS_BY_NAME",
      SEARCH_SCHOOLS_LIST: "schools/SEARCH_SCHOOLS",
      SEARCH_PRIMARY_SCHOOLS: "primarySchools/SEARCH_SCHOOLS",
      SEARCH_TEACHERS_LIST: "teachers/SEARCH_TEACHERS_LIST",
      SEARCH_STUDENTS_LIST: "students/SEARCH_STUDENTS_LIST",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
    }),
    stopClick(row) {},
    async searchName() {
      if (this.table === "primary-schools") {
        await this.SEARCH_PRIMARY_SCHOOLS();
      } else if (this.table === "students") {
        console.log("students 1");
        await this.SEARCH_STUDENTS();
      } else if (this.table === "teachers") {
        await this.SEARCH_TEACHERS();
      } else if (this.table === "trainers") {
        await this.SEARCH_TRAINERS();
      } else if (this.parent === "students-list") {
        console.log("students 2");
        await this.SEARCH_STUDENTS_LIST();
      } else if (this.parent === "schools-list") {
        await this.SEARCH_SCHOOLS_LIST();
      } else if (this.parent === "teachers-list") {
        await this.SEARCH_TEACHERS_LIST();
      } else {
        await this.SEARCH_SCHOOLS();
      }
    },
  },
  computed: {
    name: {
      get() {
        return this.$store.state.searches.name;
      },
      set(val) {
        this.$store.commit("searches/name", val);
      },
    },
    ...mapGetters({
      loading: "searches/getLoading",
      error: "searches/getError",
    }),
  },
  destroyed() {
    this.RESET_SEARCH();
  },
};
</script>

<style scoped>
.location-underline {
  text-decoration: underline;
}
</style>
